import React from 'react';
import {Box, ResultSubject, Text} from '../../../../styled';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import OfficeIcon from './OfficeIcon';
import {truncate} from 'lodash';

export const getMeetingLocation = (item: any, isPreview?:boolean) => {
  if (!item) {
    return 'Unknown location'
  }
  let location = !!item.isOnlineMeeting && item.meeting_url ?
    (
      <a href={item.meeting_url} target="office365">{truncate(item.meeting_url, { length: isPreview ? 80 : 30 })}</a>
    ) : item.location?.displayName;
  if (!location) {
    location = 'Unknown location';
  }
  return location;
}

const CalendarSnippet = ({ item }:any) => {
  const location = getMeetingLocation(item);

  return (
    <Box>
      <ResultSubject>
        <OfficeIcon type="calendar" noMargin />
        <span style={{ paddingRight: 5 }} />
        <HighlightMarker>{item.title}</HighlightMarker>
        <div style={{ width: 30, display: 'inline-block' }}>
          <OfficeIcon type="outlook" />
        </div>
      </ResultSubject>
      <Text>
        {item.dateString}
      </Text>
      <HighlightMarker>
        <Text>
          {item.resultSnippet}
        </Text>
      </HighlightMarker>
      <FileAttachments files={item.att} />
      <Text variant="muted" size="small">
        Organizer: {item.displayOrganizer} | {location}
      </Text>
    </Box>
  )
}

export default CalendarSnippet;